import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AzureLoginService } from 'src/app/services/azure-login.service';
import { TabsService } from '../../../services/tabs.service';
import { copy } from '../../../shared/utilities/common-utilities';
import { InquiryQueueService } from './inquiry-queue.service';
import { SecurityTypeService } from '../../../administration/security/security.service';

@Component({
  standalone: false,
  selector: 'inquiry-queue',
  templateUrl: 'inquiry-queue.template.html',
  styleUrls: ['inquiry-queue.scss'],
  providers: [InquiryQueueService],
})
export class InquiryQueueComponent implements OnInit {
  @Input() searchParams: any;
  allowedRoles: Set<string> = new Set();
  admin: any[];
  cols: any[];
  resultCount: number = 0;
  querySubscription: any;
  querySubscriptions: Subscription[] = [];
  isLoading: boolean = true;
  currentMaxId: number;
  disableLoadMore = false;
  offsetLimit = 10;
  dataList: any[] = [];
  lastOffsetVal = 0;
  tabKey: any;
  constructor(
    private inquiryQueueService: InquiryQueueService,
    private azureService: AzureLoginService,
    private tabService: TabsService,
    private securityService: SecurityTypeService,
  ) {}

  ngOnInit() {
    this.cols = [
      { field: 'group_name', header: 'GROUP NAME', type: 'text' },
      { field: 'userName', header: 'USER NAME', type: 'text' },
      { field: 'email', header: 'EMAIL', type: 'text' },
      { field: 'new', header: 'NEW', type: 'link' },
      { field: 'inprogress', header: 'IN PROGRESS', type: 'link' },
      { field: 'onhold', header: 'ON HOLD', type: 'link' },
      { field: 'closed', header: 'CLOSED', type: 'link' },
      { field: 'open', header: 'OPEN', type: 'link' },
      { field: 'viewall', header: 'VIEW ALL', type: 'link' },
    ];
    this.securityService
      .getRolePermissionSearch({
        permissionCategory: 'Contract',
        permissionDescription: 'Inquiry Queue Roles',
        limit: 1000,
        offset: 0,
      })
      .subscribe(
        ({ data }) => {
          this.allowedRoles = new Set<string>(
            (data?.getRolePermissionSearch || [])
              .map((r: any) => String(r.roleName || '').trim())
              .filter(Boolean),
          );
          if (this.allowedRoles.size > 0) {
            this.getInquiryQueue();
          } else {
            this.isLoading = false;
            this.dataList = [];
            this.resultCount = 0;
            this.disableLoadMore = true;
          }
        },
        (error) => {
          console.warn('Error fetching Inquiry Queue Roles permission:', error);
          this.isLoading = false;
          this.dataList = [];
          this.resultCount = 0;
          this.disableLoadMore = true;
        },
      );
  }

  getInquiryQueue() {
    let isSearchExists = false;
    this.searchParams =
      this.searchParams && typeof this.searchParams !== 'string' ? this.searchParams : {};
    Object.keys(this.searchParams).map((el) => {
      if (this.searchParams[el] !== '') {
        isSearchExists = true;
      }
    });
    this.searchParams.limit = this.offsetLimit + 1;
    this.searchParams.offset = this.lastOffsetVal;
    this.lastOffsetVal += this.offsetLimit;
    this.isLoading = true;
    this.querySubscription = this.inquiryQueueService.getInquiryQueue(this.searchParams).subscribe(
      ({ data }) => {
        this.currentMaxId = this.dataList ? this.dataList.length : 0;
        const response = copy(data.getInquiryQueue || []);
        if (response) {
          const displayResponse = response.slice(0, this.offsetLimit);
          const modifedData = displayResponse.filter((el) => {
            if (!this.isAllowedQueueItem(el)) return false;
            el.id = this.currentMaxId;
            return el;
          }).map((el) => {
            el = this.formatData(el);
            this.currentMaxId += 1;
            el.id = this.currentMaxId;
            return el;
          });

          const hasDisplayableLookahead = response
            .slice(this.offsetLimit)
            .some((el) => this.isAllowedQueueItem(el));
          this.disableLoadMore = !hasDisplayableLookahead;

          this.dataList = !!this.dataList ? [...this.dataList, ...modifedData] : [...modifedData];

          this.dataList.sort((a, b) => {
            const groupNameCompare = (a.group_name || '').localeCompare(b.group_name || '', undefined, {
              sensitivity: 'base',
              numeric: true
            });

            if (groupNameCompare !== 0) {
              return groupNameCompare;
            }

            return (a.email || '').localeCompare(b.email || '', undefined, {
              sensitivity: 'base',
              numeric: true
            });
          });

          this.resultCount = this.dataList.length;
        } else {
          this.dataList = [];
          this.disableLoadMore = true;
        }
        this.hideSpinnerAfterRowsRender();
      },
      (err) => {
        this.isLoading = false;
        throw err;
      },
    );
  }

  // FROM API row to table row data
  formatData(item) {
    return {
      id: 0,
      group_name: item.roleName,
      userName: item.userName,
      email: item.email,
      new: item.newCount,
      inprogress: item.inProgressCount,
      onhold: item.onHoldCount,
      closed: item.closedCount,
      open: item.openCount,
      viewall: item.viewAllCount,
    };
  }

  private hideSpinnerAfterRowsRender(): void {
    setTimeout(() => {
      this.isLoading = false;
    });
  }

  private isAllowedQueueItem(item): boolean {
    if (!this.allowedRoles.size || !item.roleName) {
      return true;
    }

    return this.allowedRoles.has(String(item.roleName).trim());
  }

  openTab(rowData, inquiryStatus) {
    const search = {
      azureUserId: this.azureService.accountId,
      userName: rowData.userName,
      inquiryStatus: inquiryStatus !== 'viewall' ? inquiryStatus : null,
    };
    const newTab = {
      header: 'Search Contract',
      content: search,
      type: 'SearchContract',
    };
    this.tabService.createTab(newTab);
  }
}
